export default __webpack_public_path__ + "static/media/SndLowerJDown.e97b9bfa.mp3";